export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const NECK_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceNeck: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    symmetryNeck: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    palpationNeck: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsNeckSections =
  keyof typeof NECK_FORM_INITIAL_VALUES.sections;
